import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const NavBar = () => {
  return (
    <header className="navbar">
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src="/rokaicon-r.png" alt="Roka TC" width="36" height="36" />
          <div>
            <div style={{ fontWeight: 700 }}>Roka TC</div>
            <div className="badge">Fabrication Tunisienne</div>
          </div>
        </Link>
        <nav style={{ display: 'flex', gap: 16 }}>
          <NavLink to="/" end>Accueil</NavLink>
          <NavLink to="/produits">Produits</NavLink>
          <NavLink to="/a-propos">À propos</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
